/* tslint:disable */
/* eslint-disable */
/* Code generated by ng-openapi-gen DO NOT EDIT. */

import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { PurchaseSourceApiFrom } from '../../models/purchase-source-api-from';

export interface ApiV3ServiceListPurchaseSourceGet$Plain$Params {

/**
 * Interface language
 */
  lang?: string;

/**
 * transport administration id/null
 */
  trmId?: number;
}

export function apiV3ServiceListPurchaseSourceGet$Plain(http: HttpClient, rootUrl: string, params?: ApiV3ServiceListPurchaseSourceGet$Plain$Params, context?: HttpContext): Observable<StrictHttpResponse<Array<PurchaseSourceApiFrom>>> {
  const rb = new RequestBuilder(rootUrl, apiV3ServiceListPurchaseSourceGet$Plain.PATH, 'get');
  if (params) {
    rb.query('lang', params.lang, {});
    rb.query('trmId', params.trmId, {});
  }

  return http.request(
    rb.build({ responseType: 'text', accept: 'text/plain', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as StrictHttpResponse<Array<PurchaseSourceApiFrom>>;
    })
  );
}

apiV3ServiceListPurchaseSourceGet$Plain.PATH = '/api/v3/service/ListPurchaseSource';
